import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { updateServiceStatus } from "../services/goHireService";
import { Service } from "../../types/service.type";
import { ServiceStatusEnum } from "../../enum/service.enum";

export const useUpdateServiceStatus = (
  serviceId: number,
  options?: { onSuccess?: (data: Service) => void; onError?: () => void }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: { status: ServiceStatusEnum }) => updateServiceStatus(serviceId, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.all });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.service(serviceId) });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.services() });
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.trendingServices() });
      options?.onSuccess?.(data);
    },
    onError: () => {
      options?.onError?.();
    },
  });
};
